import React from 'react';

const Icon85OrientationBumperChaiseLeft = props => (
  <svg
    focusable="false"
    viewBox="0 0 800 800"
    aria-hidden="true"
    role="presentation"
    {...props}
  >
    <path
      d="M524.49 174.1L524.49 197.59C524.49 202.66 520.38 206.77 515.31 206.77L255.49 206.77L255.49 174.1C255.49 169.03 259.6 164.92 264.67 164.92L515.31 164.92C520.38 164.92 524.49 169.03 524.49 174.1Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinejoin="round"
    />
    <path
      d="M255.49 215.77L255.49 477.42C255.49 482.39 259.52 486.42 264.49 486.42L307.74 486.42L307.74 206.77L264.49 206.77C259.52 206.77 255.49 210.8 255.49 215.77Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinejoin="round"
    />
    <path
      d="M316.74 635.08L515.49 635.08C520.46 635.08 524.49 631.05 524.49 626.08L524.49 206.78L307.74 206.78L307.74 626.08C307.74 631.05 311.77 635.08 316.74 635.08Z"
      fill="transparent"
      stroke="currentColor"
      strokeWidth="10"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon85OrientationBumperChaiseLeft;
